import { z } from 'zod/v4';

export const supplierSchema = z.object({
  code: z.string().min(1, 'suppliers.validation.codeRequired'),
  name: z.string().min(1, 'suppliers.validation.nameRequired'),
  type: z.enum(['company', 'individual']),
  taxId: z.string().optional().default(''),
  address: z.string().optional().default(''),
  city: z.string().optional().default(''),
  phone: z.string().optional().default(''),
  email: z.union([z.email(), z.literal('')]).optional().default(''),
  notes: z.string().optional().default(''),
});

export type SupplierFormData = z.infer<typeof supplierSchema>;
